module.exports = __webpack_public_path__ + "img/favourite.d1343d4a.svg";